import { REVIEW_ERROR_CODES, type ReviewErrorCode } from '@repo/api-contracts';

const MESSAGES: Readonly<Record<ReviewErrorCode, string>> = {
  REVIEW_NOT_FOUND: '후기를 찾을 수 없어요.',
  ORDER_NOT_ELIGIBLE: '취소·환불된 주문에는 후기를 쓸 수 없어요.',
  NOT_DELIVERED: '배송이 완료된 뒤에 후기를 쓸 수 있어요.',
  DEADLINE_PASSED: '후기 작성 기간(배송 완료 후 90일)이 지났어요.',
  ALREADY_WRITTEN: '이 주문에는 이미 후기를 썼어요.',
  HIDDEN_REVIEW: '숨김 처리된 후기는 수정할 수 없어요.',
  INVALID_IMAGE: '사용할 수 없는 사진이 있어요. 사진을 다시 올려 주세요.',
  CONFLICT: '후기가 바뀌었어요. 새로 불러온 뒤 다시 시도해 주세요.',
};
const SAVE_FALLBACK = '후기를 저장하지 못했어요. 잠시 후 다시 시도해 주세요.';

const isReviewErrorCode = (value: unknown): value is ReviewErrorCode =>
  typeof value === 'string' && (REVIEW_ERROR_CODES as readonly string[]).includes(value);

/** 사유 코드가 없을 때 쓰는 일반 안내는 동작마다 다르므로 호출부가 고를 수 있다(기본: 저장). */
export const reviewErrorMessage = (error: unknown, fallback: string = SAVE_FALLBACK): string => {
  if (typeof error !== 'object' || error === null || !('data' in error)) return fallback;
  const data = (error as { data: unknown }).data;
  const code =
    typeof data === 'object' && data !== null && 'reviewErrorCode' in data
      ? (data as { reviewErrorCode: unknown }).reviewErrorCode
      : null;
  return isReviewErrorCode(code) ? MESSAGES[code] : fallback;
};
